import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { useCallback } from 'react'

export function useAuthRedirect() {
  const navigate = useNavigate()
  const location = useLocation()
  const { isAuthenticated } = useAuth()

  const requireAuth = useCallback((callback?: () => void, redirectToSignup = false) => {
    if (!isAuthenticated) {
      // Constrói a URL completa atual para usar como callback
      const currentUrl = `${location.pathname}${location.search}`
      
      // Redireciona para login ou signup com o callback
      const redirectUrl = redirectToSignup 
        ? `/signup?callback=${encodeURIComponent(currentUrl)}`
        : `/login?callback=${encodeURIComponent(currentUrl)}`
      navigate(redirectUrl)
      return false
    }
    
    // Se está autenticado, executa o callback se fornecido
    if (callback) {
      callback()
    }
    return true
  }, [isAuthenticated, navigate, location.pathname, location.search])

  const redirectToLogin = useCallback((callback?: () => void) => {
    return requireAuth(callback, false)
  }, [requireAuth])

  const redirectToSignup = useCallback((callback?: () => void) => {
    return requireAuth(callback, true)
  }, [requireAuth])

  const handleAuthAction = useCallback((action: () => void) => {
    return requireAuth(action)
  }, [requireAuth])

  return {
    requireAuth,
    redirectToLogin,
    redirectToSignup,
    handleAuthAction,
    isAuthenticated
  }
}
